import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { waLink } from "../data/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink("Hello SABAKT, I'd like to discuss an industrial requirement.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-btn"
    aria-label="Chat with SABAKT on WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 font-semibold text-white shadow-2xl"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.06 }}
  >
    <MessageCircle size={20} />
    <span className="hidden text-sm sm:inline">Chat with SABAKT</span>
  </motion.a>
);
